/* LiquorVerse drops rail — paging + desktop auto-advance [2026-08-07].
   The rail itself is plain CSS scroll-snap; this file only moves it.

   - Arrows page by one viewport of cards and wrap at the ends.
   - Auto-advance runs ONLY when: the section opted in (data-lv-rail-auto),
     the viewport is desktop (arrows visible), the visitor has not asked for
     reduced motion, the rail actually overflows, and the rail is on screen
     (IntersectionObserver — a timer scrolling something off-screen is wasted
     work and a battery drain).
   - Any hover, focus or touch pauses it; leaving resumes. A visitor reading
     a card must never have it slide away under the cursor. */
(function () {
  'use strict';

  var INTERVAL_MS = 6000;
  var desktop = window.matchMedia('(min-width: 901px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRail(rail) {
    var section = rail.closest('section') || document;
    var prev = section.querySelector('[data-lv-rail-prev]');
    var next = section.querySelector('[data-lv-rail-next]');

    function page(dir) {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 4) return;
      /* Page in EXACT card-step multiples. A smooth scrollTo aimed between snap
         points fights `scroll-snap-type: mandatory` and Chromium can cancel the
         animation outright (the rail never moves). Every target below is a snap
         boundary, so the two mechanisms agree. Step = distance between the
         first two cards (card width + gap), read live so it tracks breakpoints. */
      var kids = rail.children;
      var step = kids.length > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : rail.clientWidth;
      if (step <= 0) step = rail.clientWidth;
      /* round, not floor: the last card in view has no trailing gap, so the
         viewport is one gap short of perPage*step and floor loses a card. */
      var perPage = Math.max(1, Math.round(rail.clientWidth / step));
      var target;
      if (dir > 0 && rail.scrollLeft >= max - 4) target = 0;
      else if (dir < 0 && rail.scrollLeft <= 4) target = max;
      else target = Math.round(rail.scrollLeft / step) * step + dir * perPage * step;
      target = Math.max(0, Math.min(target, max));
      scrollRail(target);
    }

    function scrollRail(target) {
      var behavior = reduced.matches ? 'auto' : 'smooth';
      var from = rail.scrollLeft;
      rail.scrollTo({ left: target, behavior: behavior });
      if (behavior !== 'smooth') return;
      /* Smooth scrolling animates on requestAnimationFrame, and throttled
         contexts (background tabs, some embedded browsers) starve rAF — the
         animation never runs and the rail silently stays put. If nothing has
         moved shortly after issuing the scroll, land the target instantly. */
      setTimeout(function () {
        if (Math.abs(rail.scrollLeft - from) < 2 && Math.abs(target - from) >= 2) {
          rail.scrollTo({ left: target, behavior: 'auto' });
        }
      }, 450);
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    if (!rail.hasAttribute('data-lv-rail-auto')) return;

    var timer = null;
    var paused = false;
    var visible = false;

    function tick() { if (!paused && visible) page(1); }
    function start() {
      if (timer || reduced.matches || !desktop.matches) return;
      timer = setInterval(tick, INTERVAL_MS);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
      rail.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      rail.addEventListener(ev, function () { paused = false; });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(rail);
    } else {
      visible = true;
    }

    desktop.addEventListener ? desktop.addEventListener('change', function (e) { e.matches ? start() : stop(); }) : null;
    reduced.addEventListener ? reduced.addEventListener('change', function (e) { e.matches ? stop() : start(); }) : null;
    start();
  }

  function boot() {
    document.querySelectorAll('[data-lv-drop-rail]').forEach(initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
